import { MultiImageUpload } from '../../../components';
import { Add, Delete } from '@mui/icons-material';
import { FC } from 'react';
import {
  Button,
  Divider,
  FormControl,
  Grid,
  TextField,
  Theme,
  Typography,
  Box
} from '@mui/material';
import { makeStyles } from '@mui/styles';

interface ISchoolDistrictProps {
  isMobile: boolean;
  schoolDistricts: any[];
  setFieldValue: (key: string, val: any) => void;
  values: any;
  handleBlur: any;
  touched: any;
  errors: any;
}

export const SchoolDistrict: FC<ISchoolDistrictProps> = ({
  isMobile,
  schoolDistricts,
  setFieldValue,
  values,
  handleBlur,
  touched,
  errors
}) => {
  return (
    <div>
      {schoolDistricts?.length > 0 &&
        schoolDistricts?.map((item, index) => (
          <SchoolDistrictItem
            key={`item-${index}`}
            isMobile={isMobile}
            districtIndex={index}
            setFieldValue={setFieldValue}
            schoolDistrict={item}
            schoolDistricts={schoolDistricts}
            values={values}
            handleBlur={handleBlur}
            touched={touched}
            errors={errors}
          />
        ))}
    </div>
  );
};

interface ISchoolDistrictItem {
  isMobile: boolean;
  schoolDistricts: any[];
  setFieldValue: (key: string, val: any) => void;
  schoolDistrict: any;
  districtIndex: number;
  values: any;
  handleBlur: any;
  touched: any;
  errors: any;
}

const SchoolDistrictItem: FC<ISchoolDistrictItem> = ({
  isMobile,
  setFieldValue,
  districtIndex,
  schoolDistricts,
  schoolDistrict,
  values,
  handleBlur,
  touched,
  errors
}) => {
  const classes = useStyles();
  return (
    <>
      <Grid
        container
        className={classes.schoolDistrictContainer}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item xs={12} sm={10}>
          <TextField
            fullWidth
            required
            variant="outlined"
            autoComplete="nope"
            label="District Name"
            name={`schoolSystem.districts.${districtIndex}.name`}
            value={schoolDistrict.name}
            onBlur={handleBlur}
            size="small"
            error={
              touched?.schoolSystem?.districts?.[districtIndex]?.name &&
              errors?.schoolSystem?.districts?.[districtIndex]?.name
                ? true
                : false
            }
            helperText={
              touched?.schoolSystem?.districts?.[districtIndex]?.name &&
              errors?.schoolSystem?.districts?.[districtIndex]?.name
            }
            onChange={e =>
              setFieldValue(`schoolSystem.districts.${districtIndex}.name`, e.target.value)
            }
          />
        </Grid>
        <Grid item xs={12}>
          <Box mt={1}>
            <Divider />
          </Box>
        </Grid>
        {schoolDistrict.schools?.length > 0 && (
          <Grid item xs={12}>
            <Box mt={0.5} marginLeft="16px">
              <Typography variant="h6">Schools</Typography>
            </Box>
          </Grid>
        )}
        <Grid item xs={12}>
          <Schools
            isMobile={isMobile}
            districtIndex={districtIndex}
            schools={schoolDistrict.schools}
            setFieldValue={setFieldValue}
            values={values}
            handleBlur={handleBlur}
            touched={touched}
            errors={errors}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Box marginLeft="16px" mt={1}>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<Add />}
              onClick={() => {
                setFieldValue(`schoolSystem.districts.${districtIndex}.schools`, [
                  ...(values.schoolSystem.districts[districtIndex].schools || []),
                  {
                    name: '',
                    files: []
                  }
                ]);
              }}
            >
              Add School
            </Button>
          </Box>
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="flex-end" mt={0.5} mb={1}>
        <Button
          id="delete"
          className={classes.deleteButton}
          startIcon={<Delete />}
          onClick={async () => {
            const result = window.confirm('Are you sure you want to delete this school district?');
            if (result) {
              const newValues = [...schoolDistricts];
              const filtered = newValues.filter((t, i) => i !== districtIndex);
              setFieldValue(`schoolSystem.districts`, filtered);
            }
          }}
        >
          Delete District
        </Button>
      </Box>
    </>
  );
};

interface ISchools {
  isMobile: boolean;
  districtIndex: number;
  schools: any[];
  setFieldValue: (key: string, val: any) => void;
  values: any;
  handleBlur: any;
  touched: any;
  errors: any;
}

const Schools: FC<ISchools> = ({
  isMobile,
  schools,
  setFieldValue,
  districtIndex,
  values,
  handleBlur,
  touched,
  errors
}) => {
  return (
    <div>
      {schools &&
        schools.length > 0 &&
        schools.map((item, index) => {
          return (
            <SchoolItem
              key={`school-item-${index}`}
              isMobile={isMobile}
              districtIndex={districtIndex}
              schoolIndex={index}
              schools={schools}
              school={item}
              setFieldValue={setFieldValue}
              values={values}
              handleBlur={handleBlur}
              touched={touched}
              errors={errors}
            />
          );
        })}
    </div>
  );
};

interface ISchoolItem {
  isMobile: boolean;
  districtIndex: number;
  setFieldValue: (key: string, val: any) => void;
  schools: any;
  school: any;
  schoolIndex: number;
  values: any;
  handleBlur: any;
  touched: any;
  errors: any;
}

const SchoolItem: FC<ISchoolItem> = ({
  setFieldValue,
  schoolIndex,
  school,
  schools,
  districtIndex,
  values,
  handleBlur,
  touched,
  errors
}) => {
  const classes = useStyles();
  return (
    <>
      <Grid
        container
        className={classes.schoolContainer}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item xs={12} sm={10}>
          <Box mt={0.5}>
            <TextField
              fullWidth
              required
              variant="outlined"
              autoComplete="nope"
              label="School Name"
              name={`schoolSystem.districts.${districtIndex}.schools.${schoolIndex}.name`}
              value={school.name}
              size="small"
              onBlur={handleBlur}
              error={
                touched?.schoolSystem?.districts?.[districtIndex]?.schools?.[schoolIndex]?.name &&
                errors?.schoolSystem?.districts?.[districtIndex]?.schools?.[schoolIndex]?.name
                  ? true
                  : false
              }
              helperText={
                touched?.schoolSystem?.districts?.[districtIndex]?.schools?.[schoolIndex]?.name &&
                errors?.schoolSystem?.districts?.[districtIndex]?.schools?.[schoolIndex]?.name
              }
              onChange={e => {
                setFieldValue(
                  `schoolSystem.districts.${districtIndex}.schools.${schoolIndex}.name`,
                  e.target.value
                );
              }}
            />
          </Box>
        </Grid>

        <Grid item xs={12}>
          <FormControl fullWidth variant="outlined" size="small">
            <MultiImageUpload
              handleFileChange={val => {
                setFieldValue(
                  `schoolSystem.districts.${districtIndex}.schools.${schoolIndex}.files`,
                  val
                );
              }}
              imageKey={`${districtIndex} - ${schoolIndex}`}
              images={
                values.schoolSystem.districts[districtIndex]?.schools[schoolIndex]?.files || []
              }
            />
          </FormControl>
        </Grid>
        <Grid container flexDirection={'row-reverse'}>
          <Grid item xs={3}>
            <div className={classes.actionButtonsSchool}>
              <Button
                id="delete"
                className={classes.deleteButton}
                startIcon={<Delete />}
                onClick={() => {
                  const result = window.confirm('Are you sure you want to delete this school?');
                  if (result) {
                    const newValues = [...schools];
                    const filtered = newValues.filter((t, i) => i !== schoolIndex);
                    setFieldValue(`schoolSystem.districts.${districtIndex}.schools`, filtered);
                  }
                }}
              >
                Delete School
              </Button>
            </div>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider className={classes.divider} />
        </Grid>
      </Grid>
    </>
  );
};
const useStyles = makeStyles((theme: Theme) => ({
  actionButtonsSchool: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '-20px'
  },

  deleteButton: {
    color: theme.palette.error.main
  },

  schoolDistrictContainer: {
    border: `1px solid ${theme.palette.grey[400]}`,
    padding: theme.spacing(1.5, 1, 1, 1)
  },
  schoolDistrictTitle: {
    marginBottom: theme.spacing(0.5)
  },

  schoolContainer: {
    padding: 8,
    marginLeft: theme.spacing(0.5)
  },
  schoolTitle: {
    marginBottom: theme.spacing(0.5)
  },
  divider: {
    marginTop: theme.spacing(1)
  }
}));
